import { FunctionComponent, useState } from "react";
import BasicButton from "@components/core/buttons/BasicButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faExclamationTriangle,
  faInfoCircle,
} from "@fortawesome/free-solid-svg-icons";
import BasicModal from "@components/core/modals/BasicModal";
import { useTranslation } from "react-i18next";
import parse from "html-react-parser";

interface InfoModalProps {
  value: string;
  warning?: boolean;
  info?: boolean;
  className?: string;
  modalClassName?: string;
  onOk?: () => void;
  linkText?: string;
  linkOnClick?: () => void;
}

const InfoModal: FunctionComponent<InfoModalProps> = ({
  value,
  warning = false,
  info = true,
  className = "",
  modalClassName = "",
  onOk,
  linkText,
  linkOnClick,
}) => {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  return (
    <>
      {" "}
      <FontAwesomeIcon
        icon={warning ? faExclamationTriangle : faInfoCircle}
        className={`app-modal-info-icon ${
          warning ? "text-danger" : ""
        } ${className}`}
        onClick={(e) => {
          setIsModalOpen(true);
          e.preventDefault();
          e.stopPropagation();
        }}
      />
      <BasicModal
        visible={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        closable={false}
        title={
          <>
            {warning && (
              <FontAwesomeIcon
                icon={faExclamationTriangle}
                className="app-modal-info-title-icon text-danger"
              />
            )}
            {warning && (
              <span className="text-danger">
                {t(`modals.info.${value}.title`)}
              </span>
            )}
            {info && (
              <FontAwesomeIcon
                icon={faInfoCircle}
                className="app-modal-info-title-icon"
              />
            )}
            {!warning && (
              <span className="white-space-pre-line">
                {t(`modals.info.${value}.title`)}
              </span>
            )}
          </>
        }
        footer={
          <BasicButton
            variant="primary"
            text={t("modals.info.dismiss")}
            onClick={() => {
              setIsModalOpen(false);
              onOk?.();
            }}
            className="w-100"
          />
        }
        className={`app-modal-info ${modalClassName}`}
      >
        <span className="white-space-pre-line">
          {parse(t("modals.info." + value + ".body"))}
          {linkText && value && <br />}
          {linkText && (
            <a
              onClick={(e) => {
                e.preventDefault();
                linkOnClick?.();
                setIsModalOpen(false);
              }}
              href="#"
            >
              {linkText}
            </a>
          )}
        </span>
      </BasicModal>
    </>
  );
};

export default InfoModal;
